import { Base } from "ui/Scripts/source/framework/base";
import { CompanyMenuItem, ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { ISavedListFilter, SavedListFilter } from "../common/savedListFilter";
import { IMessagePageData, MessagePageData } from "./messagePageData";
import { IMessageListItems, MessageListItems } from "./messageListItems";

export interface IMessagePage extends IMessagePageData {
    companies: ICompanyMenuItem[];
    list: IMessageListItems;
    companyFilters: ISavedListFilter[];
    userFilters: ISavedListFilter[];
    showDocumentPreview: boolean;
}

export class MessagePage extends MessagePageData implements IMessagePage {
    companies: CompanyMenuItem[];
    list: MessageListItems;
    companyFilters: SavedListFilter[];
    userFilters: SavedListFilter[];
    showDocumentPreview: boolean;

    constructor();
    constructor(obj: IMessagePage);
    constructor(obj?: any) {
        super(obj);
        this.companies = Base.getTypedArray(obj ? obj.companies : null, CompanyMenuItem);
        this.list = new MessageListItems(obj && obj.list || null);
        this.companyFilters = Base.getTypedArray(obj ? obj.companyFilters : null, SavedListFilter);
        this.userFilters = Base.getTypedArray(obj ? obj.userFilters : null, SavedListFilter);
        this.showDocumentPreview = obj && obj.showDocumentPreview || false;
    }
}
